(ns dashboard.i18n
  (:require
   [clojure.set :as s]
   [tongue.core :as tongue]
   [inflections.core :refer
    [*uncountable-words* *plural-rules* slurp-rules map->Rule add-rule!]]
   [dashboard.subs :as subs]
   [dashboard.i18n.en :refer [en]]
   [dashboard.i18n.ja :refer [ja]]
   [dashboard.i18n.fr :refer [fr]]
   [re-frame.core :refer [subscribe]]))

(defn tweak-inflection-rules! []
  (swap! *uncountable-words* disj "space"))

(tweak-inflection-rules!)

(def dicts {:en en
            :ja ja
            :fr fr})

(def translate (tongue/build-translate dicts))

(defn tr-keyword1 [s]
  (-> s clojure.string/lower-case (clojure.string/replace " " "-") keyword))

(defn tr-keyword2 [s]
  (-> s clojure.string/lower-case (clojure.string/replace " " "_") keyword))

(defn tr
  ([key] (translate @(subscribe [::subs/locale]) key))
  ([key x] (translate @(subscribe [::subs/locale]) key x))
  ([key x & args] (apply translate @(subscribe [::subs/locale]) key x args)))
